import React from 'react';
import { Nav } from 'reactstrap';
import { TabNavigationItem } from '../models/tabNavigationItem';
import { TabItemComponent } from './tabItem/tabItem';
import { TabDropdownComponent } from './tabDropdown';
interface NavigationPanelComponentProps {
    navigationId: string;
    activeTabIndex: number;
    visibleTabs: Array<TabNavigationItem>;
    dropdownTabs: Array<TabNavigationItem>;
    className?: string;
    upperCaseTabs?: boolean;
    inModal?: boolean;
    linkNavTabsRef: (ref: HTMLLIElement) => void;
    onTabClose: (tabIndex: number) => void;
    onTabSelect: (tabIndex: number) => void;
    onTabReset: (tabIndex: number) => void;
}

interface NavigationPanelComponentState {
    isDropdownOpen: boolean;
}

export class NavigationPanelComponent extends React.Component<NavigationPanelComponentProps, NavigationPanelComponentState> {
    public constructor(props: NavigationPanelComponentProps) {
        super(props);
        this.state = {
            isDropdownOpen: false,
        };
    }

    public render(): JSX.Element {
        return (
            <Nav id={this.props.navigationId} tabs className={this.props.className}>
                {this.props.visibleTabs.map(tab => (
                    <TabItemComponent
                        key={`tabItem${tab.index}${tab.label}`}
                        linkRef={ref => this.props.linkNavTabsRef(ref)}
                        label={tab.label}
                        disabled={tab.disabled}
                        href={tab.href}
                        activeIcon={tab.icon}
                        inModal={this.props.inModal}
                        isActive={this.props.activeTabIndex === tab.index}
                        isUpperCase={this.props.upperCaseTabs}
                        isClosable={tab.isCloseable}
                        isResetable={tab.isResetable}
                        onResetDefault={() => this.props.onTabReset(tab.index)}
                        onClick={() => this.props.onTabSelect(tab.index)}
                        onClose={() => this.props.onTabClose(tab.index)}
                        onNewTab={tab.onDuplicate}
                    />
                ))}

                <TabDropdownComponent
                    activeTabIndex={this.props.activeTabIndex}
                    isVisible={this.props.dropdownTabs.length !== 0}
                    dropdownTabs={this.props.dropdownTabs}
                    isActive={this.props.activeTabIndex >= this.props.visibleTabs.length}
                    isOpen={this.state.isDropdownOpen}
                    toggle={(): void =>
                        this.setState({
                            isDropdownOpen: !this.state.isDropdownOpen,
                        })
                    }
                    items={this.props.dropdownTabs}
                    upperCaseTabs={this.props.upperCaseTabs}
                    onTabItemClick={tabIndex => this.props.onTabSelect(tabIndex)}
                    onTabItemClose={tabIndex => this.props.onTabClose(tabIndex)}
                    onTabItemReset={tabIndex => this.props.onTabReset(tabIndex)}
                />
            </Nav>
        );
    }
}
